module.exports = __webpack_public_path__ + "VIPH21.png?37087233086a035013903f42d270a5df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH21.png
// module id = 94
// module chunks = 0